import { getOfferStats, IResponseSuccess } from '../../api/stats/get_offer_stats';
import { IThunkActionCreator } from '../index';

export interface IOfferStatsPopupState {
  dataStats: IResponseSuccess | null;
  isOpen: boolean;
  statusFetch: EStatusFetch;
  messageError: string;
}

export enum EStatusFetch {
  none,
  isLoad,
  ok,
  error,
}

export interface IOfferStatsPopupStateOpen {
  type: 'IOfferStatsPopupStateOpen';
}

export interface IOfferStatsPopupStateClose {
  type: 'IOfferStatsPopupStateClose';
}

export interface IOfferStatsPopupStateFetching {
  payload: {
    messageError: string;
    statusFetch: EStatusFetch;
  };
  type: 'IOfferStatsPopupStateFetching';
}

export interface IOfferStatsPopupStateFetchingSuccess {
  payload: {
    data: IResponseSuccess;
    statusFetch: EStatusFetch;
  };
  type: 'IOfferStatsPopupStateFetchingSuccess';
}

export interface IOfferStatsPopupStateFetchingError {
  payload: {
    messageError: string;
    statusFetch: EStatusFetch;
  };
  type: 'IOfferStatsPopupStateFetchingError';
}

export function offerStatsPopupOpen(): IOfferStatsPopupStateOpen {
  return {
    type: 'IOfferStatsPopupStateOpen',
  };
}

export function offerStatsPopupClose(): IOfferStatsPopupStateClose {
  return {
    type: 'IOfferStatsPopupStateClose',
  };
}

export function submitOfferStats(host: string, id: number): IThunkActionCreator {
  return (dispatch, getState, context) => {
    dispatch({
      payload: {
        messageError: '',
        statusFetch: EStatusFetch.isLoad,
      },
      type: 'IOfferStatsPopupStateFetching',
    });

    getOfferStats(context.custom.makeRequest, host, id)
      .then((response: IResponseSuccess) => {
        dispatch({
          payload: {
            data: response,
            statusFetch: EStatusFetch.ok,
          },
          type: 'IOfferStatsPopupStateFetchingSuccess',
        });
      })
      .catch(() => {
        dispatch({
          payload: {
            messageError: 'Не удалось загрузить данные. Попробуйте позже.',
            statusFetch: EStatusFetch.error,
          },
          type: 'IOfferStatsPopupStateFetchingError',
        });
      });
  };
}

export type TOfferStatsPopupAction =
  | IOfferStatsPopupStateOpen
  | IOfferStatsPopupStateClose
  | IOfferStatsPopupStateFetching
  | IOfferStatsPopupStateFetchingSuccess
  | IOfferStatsPopupStateFetchingError;

const initialState = {
  dataStats: null,
  isOpen: false,
  messageError: '',
  statusFetch: EStatusFetch.none,
};

export function offerStatsPopupReducer(
  state: IOfferStatsPopupState = initialState,
  action: TOfferStatsPopupAction,
): IOfferStatsPopupState {
  switch (action.type) {
    case 'IOfferStatsPopupStateOpen':
      return {
        ...state,
        isOpen: true,
      };

    case 'IOfferStatsPopupStateClose':
      return {
        ...state,
        isOpen: false,
      };

    case 'IOfferStatsPopupStateFetching':
      return {
        ...state,
        messageError: action.payload.messageError,
        statusFetch: action.payload.statusFetch,
      };

    case 'IOfferStatsPopupStateFetchingSuccess':
      return {
        ...state,
        dataStats: action.payload.data,
        statusFetch: action.payload.statusFetch,
      };

    case 'IOfferStatsPopupStateFetchingError':
      return {
        ...state,
        messageError: action.payload.messageError,
        statusFetch: action.payload.statusFetch,
      };

    default:
      return state;
  }
}
